import { useNavigator } from '@repo/toolkit/use-navigator'
import Badge from '@repo/ui/badge'
import { Column } from '@repo/ui/data-table'
import { PlusIcon, SettingIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { API } from '../../../api/apis.config'
import CountryFlag from '../../../components/elements/country-flag'
import DynamicDataTable from '../../../components/elements/dynamic-table'
import { DynamicTableRef } from '../../../components/elements/dynamic-table'
import UserNavBar from '../../../components/elements/nav-bar'
import { Paths } from '../../../lib/constants/path'
import { CanGoOutAloneCondition } from '../../../lib/types/models/can-go-out-alone-condition/can-go-out-alone-condition'
import { getTranslatedName } from '../../../lib/utils/functions/translation.functions'

export function CanGoOutAloneConditionsListPage() {
  const tableRef = useRef<DynamicTableRef<CanGoOutAloneCondition>>(null)
  const { navigate, navigateWithEvent } = useNavigator()

  const columns: Column<CanGoOutAloneCondition>[] = [
    {
      accessorKey: 'id',
      header: 'ID',
      enableSorting: true
    },
    {
      accessorKey: 'minAge',
      header: 'Âge min',
      enableSorting: true
    },
    {
      accessorKey: 'maxAge',
      header: 'Âge max',
      enableSorting: true
    },
    {
      accessorKey: 'countries',
      header: 'Pays',
      cell: ({ row }) => {
        const countries = row.original.countries

        return (
          <div className={'flex flex-wrap gap-2 py-3'}>
            {countries?.map(({ code }) => (
              <CountryFlag key={code} code={code} />
            ))}
          </div>
        )
      }
    },
    {
      accessorKey: 'formulas',
      header: 'Formules',
      cell: ({ row }) => {
        const formulas = row.original.formulas

        return (
          <div className={'flex flex-wrap gap-1'}>
            {formulas?.map((formula) => (
              <Badge key={formula.id} text={getTranslatedName(formula)} variant={'white'} />
            ))}
          </div>
        )
      }
    }
  ]

  return (
    <div>
      <UserNavBar title={'Peut sortir seul dans certaines conditions'} icon={SettingIcon} />
      <div className={'h-4'} />

      <DynamicDataTable<CanGoOutAloneCondition>
        ref={tableRef}
        title={'Peut sortir seul dans certaines conditions'}
        columns={columns}
        deleteMessage={{
          name: "cette condition avec l'ID ",
          attributeName: 'id',
          deleteAll: 'Êtes-vous sûr de vouloir supprimer toutes ces conditions ?',
          deleteMany: (data) => {
            return `Êtes-vous sûr de vouloir supprimer ces conditions avec les ID "${data
              .map((item) => item.id)
              .join('", "')}"?`
          }
        }}
        onRowClick={(row, event) =>
          navigateWithEvent(
            Paths.CAN_GO_OUT_ALONE_CONDITION_UPDATE_PAGE.replace(':id', row.id.toString()),
            event
          )
        }
        selectable
        allowSearchParam
        endpoint={API.canGoOutAloneCondition.getAll.url}
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            label: 'Créer',
            fn: () => navigate(Paths.CAN_GO_OUT_ALONE_CONDITION_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}
